import { atom } from 'jotai';

console.log(document.documentElement);

export const langAtom = atom(window.navigator.language.startsWith('zh') ? 'zh' : 'en');